// @owners { team: patients }
import { getErrorMessage } from '~shared/helpers/helper';
import { type APIError } from '~shared/types/APIError';

// Must match the error string scriptdash's CreatePaymentMethod returns for a
// fingerprint-matched duplicate - the clients key UI behavior off it until the
// endpoint grows a machine-readable error code.
export const CARD_ALREADY_SAVED_ERROR = 'Card already saved to your account.';

export const getCardSaveErrorMessage = (error: unknown): string =>
  getErrorMessage(error as APIError) ?? 'Something went wrong saving your card.';
